import { withGlobal } from "components/global/GlobalWrapper";
import { BuildingEditResidentPayments } from "./BuildingEditResidentPayments";
import { residentPaymentsReducers } from "components/stores/resident_payments/reducers";

export default withGlobal(BuildingEditResidentPayments, { reducers: residentPaymentsReducers });
